module.exports = __webpack_public_path__ + "static/media/whybtmside.9494fde2.png";